<template>
  <div>
    <modal
      ref="modal"
      :showing="showing"
      :show-close="showClose"
      :background-close="backgroundClose"
      :small="true"
      @close="close"
    >
      <div class="bg-grayVeryLight relative mx-auto lg:mx-0 p-24 lg:p-64 text-black">
        <div class="grid grid-cols-12 gap-24">
          <h1 class="h2 col-span-12">
            {{ $t('wcagModal.title') }}
          </h1>
          <div class="col-start-1 col-span-12 mb-16">
            <checkbox v-model="accessibility.highContrast"
                      name="contrastMode"
                      :label="$t('wcagModal.contrastMode')"
            >
              <span class="block text-left">{{ $t('wcagModal.contrastMode') }}</span>
            </checkbox>
            <!--            <select v-model="$root.$i18n.locale" type="select" class="language-switcher language-switcher&#45;&#45;large col-span-1">-->
            <!--              <option v-for="lang in (isEmpty(languages) ? [primaryLanguage || 'de', 'en'] : languages)" :key="lang" :value="lang">-->
            <!--                {{ getLanguageName(lang, lang) }}-->
            <!--              </option>-->
            <!--            </select>-->
          </div>

          <button-big class="col-start-1 col-span-12" @click="close">
            <span class="text-16 text-white font-medium">
              {{ $t('wcagModal.okay') }}
            </span>
          </button-big>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { XIcon } from 'vue-feather-icons';
import Modal from './Modal';
import ButtonBig from '../ButtonBig/ButtonBig';
import { isEmpty, isNil } from 'lodash/lang';
import InputSelect from '@/components/lib/InputElements/InputSelect/InputSelect.vue';
import Checkbox from '@/components/lib/InputElements/Checkbox/Checkbox.vue';

export default {
  name: 'WcagModal',

  components: {
    Checkbox,
    InputSelect,
    XIcon,
    Modal,
    ButtonBig,
  },

  props: {
    // showing: {
    //   required: true,
    //   type: Boolean,
    // },
    showClose: {
      type: Boolean,
      default: true,
    },
    backgroundClose: {
      type: Boolean,
      default: true,
    },
  },

  data: function () {
    return {
      showing: false,
      accessibility: {
        highContrast: false,
      },
    };
  },

  computed: {
    hotel() {
      return this.$store.getters.hotel;
    },
  },

  watch: {
    showing(value) {
      if (value) {
        return document.querySelector('body')
          .classList
          .add('overflow-hidden');
      }
      return document.querySelector('body')
        .classList
        .remove('overflow-hidden');
    },
    accessibility: {
      handler: function (newVal) {
        if (isNil(newVal)) return;
        this.$store.commit('accessibility', newVal);
        this.updateStyles();
      },
      deep: true,
    },
  },

  created() {
    this.$serviceBus.$on('shortcut.esc', this.close);
    this.$serviceBus.$on('wcagModal.show', () => { this.showing = true; });
    this.$serviceBus.$on('wcagModal.hide', () => {
      this.showing = false;
      // this.close();
    });

    this.accessibility = {
      ...this.$store.getters.accessibility,
    };
  },

  beforeDestroy() {
    this.$serviceBus.$off('shortcut.esc', this.close);
    this.$serviceBus.$off('wcagModal.show');
    this.$serviceBus.$off('wcagModal.hide');

    return document.querySelector('body')
      .classList
      .remove('overflow-hidden');
  },

  methods: {
    isEmpty,
    close() {
      this.$serviceBus.$emit('wcagModal.hide');
      // this.$refs.modal.close();
    },
    confirmAndClose() {
      this.$serviceBus.$emit('wcagModal.confirm', this.$root.$i18n.locale);
      this.close();
    },
    updateStyles() {
      try {
        if (this.accessibility.highContrast === true) {
          this.$root.$el.classList.add('high-contrast');
        } else {
          this.$root.$el.classList.remove('high-contrast');
        }
      } catch (e) { /* ignore */ }
    },
  },

};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.6s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
